import { mapAsync, flowAsync } from '@gcc/nodash';
import { get, flow, pick, map, groupBy, mapValues, flatten, last, curry } from 'lodash/fp';
import axios from './axios';
import config from '../../helpers/config';

export const generateOverrideKey = overrides =>
  JSON.stringify(map(pick(['choiceId', 'choiceValue', 'optionName', 'optionType']), overrides));

export const groupByOverride = flow(
  map(({ targetId, overrides }) => ({
    targetId,
    overrides,
    key: generateOverrideKey(overrides),
  })),
  groupBy('key'),
  mapValues(grouping => ({
    overrides: grouping[0].overrides,
    targetIds: map('targetId', grouping),
  })),
);

export const makeRequest = curry((designId, sourceId, { targetIds, overrides }) => axios.post(
  `${config.designBuilderLoadDesignPath}/${designId}/items/${sourceId}/cloneStyle`,
  {
    ids: targetIds,
    overrideChoices: overrides,
  },
).then(get('data')));

export const flattenResults = results => ({
  design: flow(
    last,
    get('design'),
  )(results),
  copyResults: flow(
    map('copyResults'),
    flatten,
  )(results),
});

export default (designId, sourceId, targetsWithOverrides) => flowAsync(
  groupByOverride,
  mapAsync(makeRequest(designId, sourceId)),
  flattenResults,
)(targetsWithOverrides);
